// extracted by mini-css-extract-plugin
export default {"tab":"extra-info_tab__eN2F9","hidden":"extra-info_hidden__flcpS"};